import { useEffect } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

// Light mode background color (from CSS --background: 168 20% 97%)
const LIGHT_BG_COLOR = '#F4F5F9';
// Dark mode background color (from CSS --background: 168 10% 8%)
const DARK_BG_COLOR = '#131817';

export function useStatusBar(isDarkMode?: boolean) {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      // Set status bar style based on theme
      // Style.Dark = light content (for dark backgrounds)
      // Style.Light = dark content (for light backgrounds)
      StatusBar.setStyle({ style: isDarkMode ? Style.Dark : Style.Light });

      // Set background color for Android
      StatusBar.setBackgroundColor({ color: isDarkMode ? DARK_BG_COLOR : LIGHT_BG_COLOR });

      // Show status bar to ensure proper safe area handling
      StatusBar.show();
    }
  }, [isDarkMode]);
}
